import React, { useRef, useState } from 'react';
import contriesList from 'iso-3166-1-alpha-2';
import { useDispatch } from 'react-redux';
import { RegexFields } from '../../../../../../../constants/utils/regexFields';
import {DateWithModal} from '../../../../../../../_common/dateWithModal';
import {updateRelocationDeclaration} from '../../../../../../../actions/events-api';
import * as loadings from '../../../../../../../constants/loadings/relocationDeclaration';
import $ from 'jquery';

export const FormCivil = ({ relocationDeclaration, userId, isLoading, setEditMode }) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const civilForm = useRef(null);

	const [personalData, setPersonalData] = useState({
		firstName: relocationDeclaration?.firstName,
		lastName: relocationDeclaration?.lastName,
		phoneNumber: relocationDeclaration?.phoneNumber,
		email: relocationDeclaration?.email,
	});

	return (
		<div className="card">
			<div className="card-body scroll-default py-0">
				<p className="o-60 pt-3">Modifier les informations qui ne sont pas à jour.</p>
				<form className="flex-column pt-3" ref={civilForm}>
					<div className="form-row">
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">
								Prénom *
							</label>
							<input
								required
								type="text"
								className="form-control"
								id="Prenom"
								defaultValue={personalData?.firstName}
								onChange={(e) => {
									e.preventDefault();
									setPersonalData({ ...personalData, firstName: e.target.value });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div>
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Nom">
								Nom *
							</label>
							<input
								required
								type="text"
								className="form-control"
								id="Nom"
								defaultValue={personalData?.lastName}
								onChange={(e) => {
									e.preventDefault();
									setPersonalData({ ...personalData, lastName: e.target.value });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div>

						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Email">
								Email
							</label>
							<input
								type="email"
								className="form-control"
								id="Email"
								defaultValue={personalData?.email}
								onChange={(event) => {
									setPersonalData({ ...personalData, email: event.target.value });
								}}
								pattern={RegexFields.email}
							/>
						</div>
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Téléphone">
								Téléphone
							</label>
							<input
								type="tel"
								className="form-control"
								id="Téléphone"
								placeholder="00 00 00 00 00"
								defaultValue={personalData?.phoneNumber}
								onChange={(event) => {
									setPersonalData({ ...personalData, phoneNumber: event.target.value });
								}}
								pattern={RegexFields.frenchPhoneNumber}
							/>
						</div>
					</div>
				</form>
			</div>
			<div className="card-footer pt-3">
				<button
					type="button"
					className="btn btn-light mr-2"
					onClick={() => {
						setEditMode(false);
					}}>
					Annuler
				</button>
				{isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
					<button type="button" className="btn btn-info loading-btn show">
						<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
					</button>
				) : (
					<button
						type="button"
						className="btn btn-info"
						onClick={(e) => {
							e.preventDefault();
							civilForm.current.classList.add("was-validated");
							if (civilForm.current.checkValidity()) {
								dispatch(
									updateRelocationDeclaration(userId, {
										...relocationDeclaration,
										firstName: personalData?.firstName,
										lastName: personalData?.lastName,
										phoneNumber: personalData?.phoneNUmber,
										email: personalData?.email,
									})
								).then(() => setEditMode(false));
							}
						}}>
						Sauvegarder
					</button>
				)}
			</div>
		</div>
	);
};